export default "__VITE_ASSET__BiYOd0zp__"